/**
 * Configuration rule Test & Simulation routes (empty placeholders until specs are defined).
 */

export const CONFIGURATION_RULE_TEST_MODULES = [
  {
    key: 'validation',
    basePath: '/admin/configuration/validation',
    pageTitle: 'Validation Rule Test & Simulation',
  },
  {
    key: 'workflow',
    basePath: '/admin/configuration/workflow',
    pageTitle: 'Workflow Rule Test & Simulation',
  },
  {
    key: 'content-control',
    basePath: '/admin/configuration/content-control',
    pageTitle: 'Content Control Rule Test & Simulation',
  },
  {
    key: 'publishing',
    basePath: '/admin/configuration/publishing',
    pageTitle: 'Publishing Rule Test & Simulation',
  },
  {
    key: 'search-matching',
    basePath: '/admin/configuration/search-matching',
    pageTitle: 'Search & Matching Rule Test & Simulation',
  },
  {
    key: 'documents',
    basePath: '/admin/configuration/documents',
    pageTitle: 'Document Rule Test & Simulation',
  },
  {
    key: 'case-actions',
    basePath: '/admin/configuration/case-actions',
    pageTitle: 'Case Action Rule Test & Simulation',
  },
  {
    key: 'limits',
    basePath: '/admin/configuration/limits',
    pageTitle: 'Limit Rule Test & Simulation',
  },
  {
    key: 'automation',
    basePath: '/admin/configuration/automation',
    pageTitle: 'Automation Rule Test & Simulation',
  },
  {
    key: 'lifecycle',
    basePath: '/admin/configuration/lifecycle',
    pageTitle: 'Lifecycle Rule Test & Simulation',
  },
  {
    key: 'retention',
    basePath: '/admin/configuration/retention',
    pageTitle: 'Retention Rule Test & Simulation',
  },
  {
    key: 'notifications',
    basePath: '/admin/configuration/notifications',
    pageTitle: 'Notification Rule Test & Simulation',
  },
];

export function getConfigurationRuleTestBasePath(moduleKey) {
  return CONFIGURATION_RULE_TEST_MODULES.find((m) => m.key === moduleKey)?.basePath ?? '';
}

export function getConfigurationRuleTestPath(moduleKey, ruleNameSlug) {
  const basePath = getConfigurationRuleTestBasePath(moduleKey);
  if (!basePath || !ruleNameSlug) return '';
  return `${basePath}/${ruleNameSlug}/test`;
}

export function navigateToConfigurationRuleTest(navigate, moduleKey, ruleNameSlug, state = {}) {
  const path = getConfigurationRuleTestPath(moduleKey, ruleNameSlug);
  if (!path) return;
  navigate(path, { state });
}

export function getConfigurationRuleTestRouteContext(pathname) {
  for (const module of CONFIGURATION_RULE_TEST_MODULES) {
    const prefix = `${module.basePath}/`;
    const suffix = '/test';
    if (!pathname.startsWith(prefix) || !pathname.endsWith(suffix)) continue;
    const ruleName = pathname.slice(prefix.length, -suffix.length);
    if (!ruleName || ruleName === 'add') continue;
    return { ...module, ruleName };
  }

  return null;
}

export function isConfigurationRuleTestPath(pathname) {
  return Boolean(getConfigurationRuleTestRouteContext(pathname));
}
